<ul class="harp-help-text list-unstyled">
  <li>
    <span class="harp-pass-invalid" *ngIf="pwd.length <= 14">
      <i class="icon ion-md-close" aria-hidden="true"></i>
      <span class="visually-hidden">Password is not</span>
      At least 15 characters
    </span>
    <span class="harp-pass-valid" *ngIf="pwd.length > 14">
      <i class="icon ion-md-checkmark" aria-hidden="true"></i>
      <span class="visually-hidden">Password is</span>
      At least 15 characters
    </span>
  </li>
  <li>
    <span class="harp-pass-invalid" *ngIf="!lowerLetters">
      <i class="icon ion-md-close" aria-hidden="true"></i>
      <span class="visually-hidden">Password does not</span>
      Include a lowercase letter
    </span>
    <span class="harp-pass-valid" *ngIf="lowerLetters">
      <i class="icon ion-md-checkmark" aria-hidden="true"></i>
      <span class="visually-hidden">Password does</span>
      Include a lowercase letter
    </span>
  </li>
  <li>
    <span class="harp-pass-invalid" *ngIf="!upperLetters">
      <i class="icon ion-md-close" aria-hidden="true"></i>
      <span class="visually-hidden">Password does not</span>
      Include an uppercase letter
    </span>
    <span class="harp-pass-valid" *ngIf="upperLetters">
      <i class="icon ion-md-checkmark" aria-hidden="true"></i>
      <span class="visually-hidden">Password does</span>
      Include an uppercase letter
    </span>
  </li>
  <li>
    <span class="harp-pass-invalid" *ngIf="!numbers">
      <i class="icon ion-md-close" aria-hidden="true"></i>
      <span class="visually-hidden">Password does not</span>
      Include a number (0-9)
    </span>
    <span class="harp-pass-valid" *ngIf="numbers">
      <i class="icon ion-md-checkmark" aria-hidden="true"></i>
      <span class="visually-hidden">Password does</span>
      Include a number (0-9)
    </span>
  </li>
  <li>Cannot contain first name, last name, or part of user ID</li>
</ul>
